import React from 'react';
import { connect } from 'react-redux';

// Components
import { Grid, Card, IconButton } from '@material-ui/core';
import Header from 'Components/common/Header';
import Dialog from 'Components/common/Dialog';
import BasicButton from 'Components/common/BasicButton';
import LoadingIcon from 'Components/icons/LoadingIcon';
import { openNotification } from 'Actions/notification';
import Counter from 'Components/counter/Counter';
import BasicInput from 'Components/common/BasicInput';
import ReplenishmentProductDetailsCard from 'Components/replenishment/ReplenishmentProductDetailsCard';
import { loadLanguage } from 'Utils/jwtUtil';
import util from 'Utils/commonUtil';

// Actions
import { viewF1Order, updateF1Order, cancelF1Order, queryInvalidSku } from 'Actions/replenishment';

// Icons
import { AddCircle } from '@material-ui/icons';
import { T } from 'Actions/translate';

class ShippedF1OrderDetails extends React.Component {

    state = {
        listLoaded: true,
        updated: false,
        updatedProduct: [],
        updateProductId: [],
        SKU: '',
        num: 1,
        addFlq: false,
        cancelOrderDialogOpened: false,
        querySkuMassage: [],
        querySkuDialogOpened: false
    }

    componentWillMount() {
        const { localData } = this.props;

        this.props.viewF1Order(localData.orderId, this.hideLoading);
    }

    goBack = () => this.props.history.goBack();

    setUpdateStatus = (f1OrderProduct, num) => {
        let updatedProduct = this.state.updatedProduct;
        let updateProductId = this.state.updateProductId;
        let index = updateProductId.indexOf(f1OrderProduct.id);

        if (index === -1) {
            updateProductId.push(f1OrderProduct.id);

            updatedProduct.push({
                'orderProductId': f1OrderProduct.id,
                'quantity': num
            });
        } else {
            updatedProduct[index].quantity = num;
        }

        this.setState({
            updated: true
        })
    }

    cancelOrder = () => {
        const { localData } = this.props;

        this.props.cancelF1Order({'id': localData.orderId}, ).then(() => {
            this.setState({ cancelOrderDialogOpened: false });
            this.goToOrderListPage();
        });
    }

    goToOrderListPage = (res) => {
        this.props.history.push('/AdminF1OrderList');
    }

    updateOrder = (addFlq) => {
        const { localData } = this.props;
        let params

        if (addFlq) {
            params = {skuList: [this.state.SKU]};
            this.props.queryInvalidSku(params, this.querySku)
        } else {
            params = {
                'orderId': localData.orderId,
                'productQuantity': this.state.updatedProduct
            }
            this.props.updateF1Order(params, this.updateResult);
        }    
    }

    querySku = (res) => {
        if (res.data.length === 0) {
            const { localData } = this.props;
            let params;
            params = {
                'orderId': localData.orderId,
                'productQuantity': [{
                    sku: this.state.SKU,
                    quantity: this.state.num
                }]
            }
            this.setState({
                'SKU': '',
                'num': 1,
                'addFlq': false
            })
            this.props.updateF1Order(params, this.updateResult);    
        } else {
            this.setState({ 
                querySkuMassage: res.data,
                querySkuDialogOpened: true
            });
        }
    }
    
    updateResult = (res) => {
        const { localData } = this.props;

        if (res.status === 'success') {
            this.props.viewF1Order(localData.orderId, this.hideLoading).then(() => {
                this.setState({ updated: false });
            }).catch(() => {
                this.setState({ updated: false });
            });

            this.setState({
                updatedProduct: [],
                updateProductId: []
            })
        } else {
            this.props.openNotification(res.status, 'danger')
        }
    }

    addNewProduct = () => {
        this.setState({
            'addFlq': true
        })
    }

    handleChange = (name, value) => {
        this.setState({ [name]: value });
    };

    changeNum = (num) => {
        this.setState({
            'num': num
        })
    }

    hideLoading = () => {
        this.setState({
            'listLoaded': false
        })
    }

    openDialog = key => !this.state[key] && this.setState({ [key]: true });
    dialogDidClose = key => this.state[key] && this.setState({ [key]: false });
    querySkuDialogClose = () => {
        this.setState({ 
            querySkuMassage: [],
            querySkuDialogOpened: false
        });
    }

    render() {
        const { f1OrderDetails } = this.props;
        const { listLoaded, updated, SKU, addFlq, cancelOrderDialogOpened, querySkuDialogOpened, querySkuMassage } = this.state;
        let lang = loadLanguage();

        return (
            <div className='shipped-f1-order-details container-max-width'>
                <div className='container-max-width is-fixed background'></div>
                <div className='container-max-width is-fixed background-cover'></div>

                <Header hasUserCenter={ true }
                        hasArrowBackIos={ true }
	      				increment={0}>
                    <Grid className='supply-center-container no-margin' container spacing={0} justify={'space-evenly'}>
                        <Grid className='supply-center-title text-ellipsis' item xs={7}>
                            <span>{T('fone_order_current_is')} {f1OrderDetails.supplyCenterName}</span>
                        </Grid>

                        <Grid className='add-product-icon' onClick={this.addNewProduct.bind(this)} item xs={1}>
                            <IconButton color='inherit'>
                                <AddCircle/>
                            </IconButton>
                        </Grid>

                        <Grid className='add-product-content' onClick={this.addNewProduct.bind(this, true)} item xs={3}>
                            <span>{T('fone_order_add_sku')}</span>
                        </Grid>
                    </Grid>

                </Header>

                { listLoaded ? <LoadingIcon className="circle-animation"/> :
                                <Grid className='order-product-container no-margin' container spacing={0} justify={'space-evenly'}>
                                    <Grid item xs={11}>
                                        { addFlq ? <Card className='new-product-card' >
                                            <Grid className='new-product-content' container spacing={0}>

                                                <Grid className='sku-input' item xs={11}>
                                                    <BasicInput title={'SKU'}
                                                                inputValid={this.handleChange}
                                                                placeholder={T('enter_sku_need_add')}
                                                                type='text'/>
                                                </Grid>

                                                <Grid item xs={3}/>

                                                <Grid className='counter' item xs={4}>
                                                     <Counter inputValid={this.changeNum} defalutValue={1} options={{ value: 0, min: 1}}></Counter>
                                                </Grid>

                                                <Grid className='add-to-shopping-cart' item xs={5}>
                                                    <BasicButton type='primary' disabled={!SKU} onClickOfSingleTap={this.updateOrder.bind(this, true)}>
                                                        {T('fone_order_add_to_cart')}
                                                    </BasicButton>
                                                </Grid>
                                            </Grid>
                                        </Card> : null }
                                    </Grid>
                                    {
                                        f1OrderDetails.orderProducts && f1OrderDetails.orderProducts.map((item, i) => {
                                            return  <Grid item xs={11} key={item.id}>
                                                        <ReplenishmentProductDetailsCard f1OrderProduct={item}
                                                                                         changeNum={this.setUpdateStatus}/>
                                                    </Grid>
                                        })
                                    }
                                </Grid>
                }

                <Grid className='page-bottom-container no-margin container-max-width is-fixed' container spacing={0} justify={'space-evenly'}>

                    <Grid item xs={3}/>

                    <Grid className={util.getClassName({
						'cancel-order-button': true && lang !== 'EN',
						'en-cancel-order-button': true && lang === 'EN'
					}) } item xs={4}>
                        <BasicButton type='primary' disabled={false} onClickOfSingleTap={ () => this.openDialog('cancelOrderDialogOpened') }>
                            <span>{T('fone_order_cancel_order')}</span>
                        </BasicButton>
                    </Grid>

                    <Grid className={util.getClassName({
						'update-order-button': true && lang !== 'EN',
						'en-update-order-button': true && lang === 'EN'
					}) } item xs={4}>
                        <BasicButton type='primary' disabled={!updated} onClickOfSingleTap={this.updateOrder.bind(this, false)}>
                            <span>{T('fone_order_update_order')}</span>
                        </BasicButton>
                    </Grid>
                </Grid>

                <Dialog opened={ cancelOrderDialogOpened } dialogDidClose={ () => this.dialogDidClose('cancelOrderDialogOpened') } options={{ bgClickClose: true }}>
                    <div className="confirm-cancel-F1-order-dialog">
                        <h5>{T('fone_order_confirm_cancel_order')}</h5>
                        <p>{T('fone_order_confirm_cancel_order_message')}</p>
                        <BasicButton className="confirm-btn" type="primary" onClickOfSingleTap={ this.cancelOrder }>{T('fone_order_confirm')}</BasicButton>
                    </div>
                </Dialog>

                <Dialog opened={ querySkuDialogOpened } dialogDidClose={ this.querySkuDialogClose } options={{ bgClickClose: true }}>
                    <div className="confirm-cancel-F1-order-dialog">
                        <h5>{T('fone_order_query_by_sku')}</h5>
                        <p>
                            {querySkuMassage[0] && querySkuMassage[0].sku ? querySkuMassage[0].sku : ''} 
                            {T('black_list_sku_reason')}：{querySkuMassage[0] && querySkuMassage[0].reason ? querySkuMassage[0].reason : ''}
                        </p>
                        <BasicButton className="confirm-btn" type="primary" onClickOfSingleTap={ this.querySkuDialogClose }>{T('getInfo')}</BasicButton>
                    </div>
                </Dialog>
            </div>
        );
    }
}

const mapStateToProps = state => {
    const { localData, replenishment } = state;
	return {
        localData: localData,
        f1OrderDetails: replenishment.f1OrderDetails,
	};
};

const mapDispatchToProps = {
    viewF1Order,
    cancelF1Order,
    updateF1Order,
    queryInvalidSku,
    openNotification
};

export default connect(mapStateToProps, mapDispatchToProps)(ShippedF1OrderDetails);
